import { render, staticRenderFns } from "./CommonQuestions.vue?vue&type=template&id=5eabc4dc&scoped=true&"
import script from "./CommonQuestions.vue?vue&type=script&lang=js&"
export * from "./CommonQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eabc4dc",
  null
  
)

export default component.exports